import React, { useState } from "react";
import { Modal, Form, Button, Select, Row, Col } from "antd";
import dayjs from "dayjs";

import useCreate from "hooks/useCreate";
import useFormErrors from "hooks/useFormErrors";
import { useQueryClient } from "@tanstack/react-query";
import { useWorkers } from "context/providers/workers";
import InputDate from "components/InputDate";
import disabled_note_datetime from "helpers/disabled_note_datetime";
import { useAuth } from "context/providers/auth";

const CreateVacationModal = () => {
  const queryClient = useQueryClient();
  const {
    state: { user },
  } = useAuth();
  const { all_users_list_options } = useWorkers();
  const [is_open_create_modal, setOpenCreateModal] = useState(false);

  const [form] = Form.useForm();

  const { pristine, has_error, onFieldsChange } = useFormErrors();

  const { is_saving, create } = useCreate({
    path: "/vacations",
    form,
    onSuccess: () =>
      queryClient.refetchQueries({
        queryKey: ["vacations"],
      }),
  });

  const handleOk = () => form.submit();
  const handleClose = () => setOpenCreateModal(false);

  return (
    <>
      <Button
        type="primary"
        htmlType="button"
        onClick={() => setOpenCreateModal(true)}
      >
        Dodaj urlop
      </Button>
      <Modal
        style={{ top: 45 }}
        maskClosable={false}
        title="Dodaj urlop"
        open={is_open_create_modal}
        onOk={handleOk}
        onCancel={handleClose}
        cancelText="Anuluj"
        okText="Dodaj"
        okButtonProps={{
          disabled: pristine || has_error,
          loading: is_saving,
        }}
      >
        <Form
          form={form}
          layout="vertical"
          onFieldsChange={onFieldsChange}
          initialValues={{
            date_start: "",
            date_end: "",
            user_id: user.id,
          }}
          onFinish={async (values) => {
            try {
              await create(values);
              form.resetFields();
              handleClose();
            } catch (error) {
              throw error;
            }
          }}
        >
          <Form.Item
            label="Pracownik"
            name="user_id"
            hasFeedback
            rules={[
              {
                required: true,
                message: "Pracownik jest wymagany!",
              },
            ]}
          >
            <Select
              placeholder="Pracownik"
              options={all_users_list_options}
              defaultValue={all_users_list_options.find(
                ({ value }) => value === user.id
              )}
            />
          </Form.Item>

          <Row gutter={[12, 12]}>
            <Col xs={24} md={24} lg={12} xl={12}>
              <Form.Item
                label="Data rozpoczęcia"
                name="date_start"
                rules={[
                  {
                    required: true,
                    message: "Data rozpoczęcia jest wymagana!",
                  },
                ]}
              >
                <InputDate
                  format="DD-MM-YYYY HH:mm"
                  disabledTime={disabled_note_datetime}
                  showTime={{
                    hideDisabledOptions: true,
                    format: "HH:mm",
                    defaultValue: dayjs("08:00", "HH:mm"),
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={24} lg={12} xl={12}>
              <Form.Item
                label="Data zakończenia"
                name="date_end"
                rules={[
                  {
                    required: true,
                    message: "Data zakończenia jest wymagana!",
                  },
                  {
                    validator: (_, value, callback) => {
                      const date_start = form.getFieldValue("date_start");
                      const date_end = value;
                      date_start && date_end && date_end - date_start < 0
                        ? callback(
                            "Data zakończenia nie może być wcześniej niż data rozpoczecia!"
                          )
                        : callback();
                    },
                  },
                ]}
              >
                <InputDate
                  format="DD-MM-YYYY HH:mm"
                  disabledDate={(current) =>
                    current && current < form.getFieldValue("date_start")
                  }
                  disabledTime={disabled_note_datetime}
                  showTime={{
                    hideDisabledOptions: true,
                    format: "HH:mm",
                    defaultValue: dayjs("16:00", "HH:mm"),
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};

export default CreateVacationModal;
